const getModuleState = state => state.higherLower;
export const getGame = state => getModuleState(state).game;
